import styled from "styled-components";

export default styled.mark`
	display: inline;
	background-color: var(--accent);
	padding: 0 .05rem;
`;
